import { render, staticRenderFns } from "./startClassRecord.vue?vue&type=template&id=4c0441f2&scoped=true"
import script from "./startClassRecord.vue?vue&type=script&lang=js"
export * from "./startClassRecord.vue?vue&type=script&lang=js"
import style0 from "./startClassRecord.vue?vue&type=style&index=0&id=4c0441f2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c0441f2",
  null
  
)

export default component.exports